import { refreshCmmdForgeRuntimeList } from "~/cmmd/cmmdForgeRuntimeListResource";
import { buildPrimaryFetchInit, resolvePrimaryEnvironmentHttpUrl } from "../environments/primary";

/**
 * Register a CMMD project on this user's Forge Cloud surface.
 *
 * This is ALL that importing a cloud project does now. It writes one row and
 * returns; no sprite is created, no repo is cloned, nothing boots. The
 * workspace is provisioned the first time the user opens a thread on the
 * project (`connectCloudCatalogRow`), which is where the wait is explicable.
 *
 * Import used to run `/forge-runtimes/ensure` + `/connect` here — a ~400s cold
 * provision paid up front for a project the user had not started working in.
 */
export async function registerCloudProject(input: {
  readonly cmmdProjectId: number;
}): Promise<void> {
  const response = await fetch(
    resolvePrimaryEnvironmentHttpUrl("/api/cmmd/forge-cloud-projects"),
    buildPrimaryFetchInit({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ projectId: input.cmmdProjectId, source: "import" }),
    }),
  );
  if (!response.ok) {
    const errBody = (await response.json().catch(() => ({}))) as { error?: string };
    throw new Error(errBody.error ?? `Could not add the project to Forge Cloud.`);
  }
  // Surface the new row immediately instead of waiting for the next SSE tick.
  refreshCmmdForgeRuntimeList();
}
